import {BrowserRouter, Navigate, Route, Routes, useLocation} from "react-router-dom";
import LoginPage from "./login/LoginPage";
import "../style/common/_common.scss"
import LoginCodeInputPage from "./login/LoginCodeInputPage";
import Error404Page from "./error/Error404Page";
import TemplateInputPage from "./template/TemplateInputPage";
import TemplatePage from "./template/TemplatePage";
import OrderInputListPage from "./order/OrderInputListPage";
import OrderHistoryListPage from "./order/OrderHistoryListPage";
import {AnimatePresence} from "framer-motion";
import AnimatedPage from "./components/wrapper/AnimatedPage.tsx";
import AuthWrapper from "./components/wrapper/AuthWrapper.tsx";
import MyDesignCardPage from "./mydesign/MyDesignCardPage.tsx";

const RouteContent = () => {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                {/*ログイン管理*/}
                <Route path="/login/" element={<AnimatedPage><LoginPage /></AnimatedPage>} />
                <Route path="/login/code" element={<AnimatedPage><LoginCodeInputPage /></AnimatedPage>} />
                {/*ホームページ*/}
                {/*<Route path="/"
                       element={<AnimatedPage>
                           <AuthWrapper>
                               <TopPage />
                           </AuthWrapper>
                       </AnimatedPage>}/>*/}
                <Route path="/"
                       element={<Navigate to="/order/input" replace />}/>
                {/*テンプレート管理*/}
                <Route path="/template/"
                       element={<AnimatedPage>
                           <AuthWrapper>
                               <TemplatePage />
                           </AuthWrapper>
                        </AnimatedPage>}/>
                <Route path="/template/input/:kbn"
                       element={<AnimatedPage>
                           <AuthWrapper>
                               <TemplateInputPage />
                           </AuthWrapper>
                        </AnimatedPage>} />
                <Route path="/mydesign/card/"
                       element={<AnimatedPage>
                           <AuthWrapper>
                               <MyDesignCardPage />
                           </AuthWrapper>
                       </AnimatedPage>} />
                {/*注文管理*/}
                <Route path="/order/input/"
                       element={<AnimatedPage>
                           <AuthWrapper>
                               <OrderInputListPage />
                           </AuthWrapper>
                        </AnimatedPage>} />
                <Route path="/order/history/"
                       element={<AnimatedPage>
                           <AuthWrapper>
                               <OrderHistoryListPage />
                           </AuthWrapper>
                        </AnimatedPage>} />
                {/*エラー管理*/}
                <Route path="/error/" element={<AnimatedPage><Error404Page /></AnimatedPage>} />
                <Route path="*" element={<AnimatedPage><Error404Page /></AnimatedPage>} />
            </Routes>
        </AnimatePresence>
    );
};

const App = () => {
    return (
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true}}
        >
            <RouteContent />
        </BrowserRouter>
    );
}

export default App;